<template>
  <div class="uploader" v-if="display">
    <div class="uploader_close_container" @click="closeUploader">X</div>
    <div class="uploader_container">
      <div class="uploader_show_box">
        <div v-for="file in files" class="uploader_show_one">
          <div v-if="file['type'].startsWith('image')" class="uploader_one">
            <img :src="createUrlObject(file)" class="uploader_one"/>
          </div>
          <div v-if="file['type'].startsWith('video')" class="uploader_one">
            <video controls preload="none">
              <source :src="createUrlObject(file)" :type="file.type"/>
            </video>
          </div>
          <div v-if="file['type'].startsWith('audio')" class="uploader_one">
            <audio controls preload="none">
              <source :src="createUrlObject(file)" :type="file.type"/>
            </audio>
          </div>
          <div v-if="file['type'].startsWith('application')" class="uploader_one">
            {{file.name}}
          </div>
        </div>
      </div>
      <div class="uploader_container_btn_box">
        <div class="uploader_container_btn">
          <i class="el-icon-close" @click="closeUploader"></i>
        </div>
        <div class="uploader_container_btn">
          <i class="el-icon-upload2" v-if="!uploading" @click="uploaderUpload"></i>
          <i class="el-icon-loading" v-if="uploading"></i>
        </div>
        <div class="uploader_container_btn">
          <input type="file" ref="fileup" @change="uploaderChoosed" multiple :accept="type" hidden/>
          <i class="el-icon-folder-opened" @click="uploaderChoose" v-if="!uploading"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { uploadFile } from '../api/api';
  export default {
    name: "uploader",
    data(){
      return {
        display:false,
        uploading:false,
        files:[],
        type:'*/*',
        result:{images:[],videos:[],audios:[],files:[]},
        imageType:['png','jpg','jpeg','bmp','webp','tiff'],
        videoType:['mp4','webm','avi','flv','rm','swf','mpg','mpeg','wmv','mov'],
        audioType:['mp3','wav','pcm','aac','opus','flac','ogg','m4a','amr','speex','lyb','ac3','ape','m4r','acc','wma','mov'],
        fileType:['pdf','doc','docx','xls','xlsx']
      }
    },
    mounted(){

    },
    methods:{
      createUrlObject(file){
        return URL.createObjectURL(file);
      },
      openUploader(type){
        if(type && type!=null && type !== '') this.type = type;
        this.display = true;
        this.clearUploader();
      },
      closeUploader(){
        this.clearUploader();
        this.display = false;
      },
      clearUploader(){
        this.files = [];
        this.result = {images:[],videos:[],audios:[],files:[]};
        this.uploading = false;
      },
      uploaderChoose(){
        this.$refs.fileup.click();
      },
      uploaderChoosed(e){
        let files = e.target.files;
        let errors = [];
        for(let f in files){
          if(typeof files[f] !== 'object') continue;
          let namesp = files[f]['name'].split(".");
          let ext = namesp[namesp.length-1].toLowerCase();
          if(this.imageType.indexOf(ext)===-1 && this.videoType.indexOf(ext)===-1 && this.audioType.indexOf(ext)===-1 && this.fileType.indexOf(ext)===-1){
            errors.push(files[f]);
            continue;
          }
          this.files.push(files[f]);
        }
        if(errors.length > 0){
          let efilenames = '';
          for(let er in errors){
            efilenames += errors[er]['name']+','
          }
          this.$alert(efilenames+'文件类型非法','提示',{
            center:true,
            type:'warning',
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }
      },
      uploaderUpload(){
        let files = this.files;
        if(!files || files.length===0){
          this.$alert('请先选择要上传的文件','错误提示',{
            center:true,
            type:'error',
            confirmButtonText: '确定',
            callback: action => {

            }
          });
          return;
        }
        this.uploading = true;
        let params = new FormData();
        for(let f in files){
          params.append('files',files[f]);
        }
        uploadFile(params).then(res => {
          if(res && res.status === 0){
            this.uploaderResult(res.data);
            this.closeUploader();
          }else{
            this.$alert(res.message,'错误提示',{
              center:true,
              type:'error',
              confirmButtonText: '确定',
              callback: action => {

              }
            });
          }
        }).catch(e => {
          this.$alert(e.message,'错误提示',{
            center:true,
            type:'error',
            confirmButtonText: '确定',
            callback: action => {

            }
          });
        }).finally(f => {
          this.uploading = false;
        });
      },
      uploaderResult(data){
        for(let r in data){
          if(parseInt(data[r]['status'])!==0) continue;
          if(this.imageType.indexOf(data[r]['ext'])>=0 || this.type.indexOf('image')>=0){
            this.result['images'].push(data[r]);
          }
          if(this.videoType.indexOf(data[r]['ext'])>=0 || this.type.indexOf('video')>=0){
            this.result['videos'].push(data[r]);
          }
          if(this.audioType.indexOf(data[r]['ext'])>=0 || this.type.indexOf('audio')>=0){
            this.result['audios'].push(data[r]);
          }
          if(this.fileType.indexOf(data[r]['ext'])>=0 || this.type === '*/*'){
            this.result['files'].push(data[r]);
          }
        }
        this.$emit('uploaderResult',this.result);
      }
    }
  }
</script>

<style scoped>
  .uploader {
    position:absolute;
    top:0;
    left:0;
    display: inline-block;
    width:100%;
    height:94vh;
    background-color:rgba(0,0,0,0.9);
    z-index:99;
    overflow-y:scroll;
  }
  .uploader_container {
    position:absolute;
    top:0;
    left:0;
    width:100%;
    height:94vh;
  }
  .uploader_close_container {
    position:absolute;
    top:1vh;
    left:0;
    text-align:right;
    width:97%;
    margin-right:3%;
    font-size:1rem;
    color:white;
    cursor:pointer;
    z-index:999;
  }
  .uploader_container_btn_box {
    position:absolute;
    top:80vh;
    left:0;
    width:100%;
    height:5rem;
    text-align:center;
  }
  .uploader_container_btn {
    float:left;
    height:3rem;
    width:30%;
    margin-left:3%;
    line-height:3rem;
    border-radius:1.5rem;
    font-size:3rem;
    color:rgba(255,255,255,0.3);
  }
  .uploader_show_box {
    position:absolute;
    top:6vh;
    left:0;
    width:100%;
    height:70vh;
    overflow-y:scroll;
  }
  .uploader_show_one {
    float:left;
    width:30%;
    margin-left:3%;
    height:20vh;
    border:rgba(255,255,255,0.5);
  }
  .uploader_one {
    text-align:center;
    vertical-align: middle;
    width:100%;
    height:20vh;
    line-height:20vh;
    color:white;
  }
</style>



// WEBPACK FOOTER //
// src/components/uploader.vue